(() => {
  const disclosures = document.querySelectorAll('.charms__disclosure');
  for (const disclosure of disclosures) {
    const fieldset = disclosure.querySelector('.charms-selection');
    if (!fieldset) continue;

    const tabs = fieldset.querySelectorAll('[data-charms-tab]');
    const panels = fieldset.querySelectorAll('[data-charms-panel]');

    const activateTab = (tabValue) => {
      for (const tab of tabs) {
        const isActive = tab.dataset.charmsTab === tabValue;
        tab.classList.toggle('charms__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        tab.tabIndex = isActive ? 0 : -1;
      }

      for (const panel of panels) {
        const isActive = panel.dataset.charmsPanel === tabValue;
        panel.classList.toggle('charms__tab-panel--active', isActive);
        panel.hidden = !isActive;
      }
    };

    if (tabs.length > 0 && panels.length > 0) {
      let initialTab = tabs[0].dataset.charmsTab;
      for (const tab of tabs) {
        if (tab.classList.contains('charms__tab--active')) {
          initialTab = tab.dataset.charmsTab;
          break;
        }
      }

      activateTab(initialTab);

      for (const tab of tabs) {
        tab.addEventListener('click', () => {
          activateTab(tab.dataset.charmsTab);
        });
      }
    }

    const max = parseInt(fieldset.dataset.maxCharms, 10);
    const maxAllowed = Number.isFinite(max) && max > 0 ? max : Infinity;

    const checkboxes = fieldset.querySelectorAll('input[type="checkbox"][name^="items"][name$="[id]"]');
    const cards = fieldset.querySelectorAll('[data-charm-card]');
    const form = disclosure.querySelector('form.charms__drawer');
    if (!form) continue;

    const submit = form.querySelector('button[name="add"]');
    const selectedCount = disclosure.querySelector('[data-charms-selected-count]');
    const selectedContainer = disclosure.querySelector('.charms__selected');
    const selectedSlotsContainer = disclosure.querySelector('[data-charms-selected-slots]');
    const selectedSlots = selectedSlotsContainer?.querySelectorAll('[data-charms-slot]') || [];
    const removeLabel = selectedContainer?.dataset.charmsRemoveLabel || '';
    const initiallyDisabled = !!submit?.disabled;

    // Remember which charms are initially disabled (e.g., out of stock)
    const initialDisabled = new WeakMap();
    for (const cb of checkboxes) initialDisabled.set(cb, cb.disabled);

    const createSlotContent = ({
      title = '',
      image = '',
      empty = false,
      removeLabelText = '',
      variantId = '',
    } = {}) => {
      const slotContent = document.createElement('div');
      slotContent.className = empty
        ? 'charms__selected-slot-content charms__selected-slot-content--empty'
        : 'charms__selected-slot-content';

      if (!empty && variantId) {
        const removeButton = document.createElement('button');
        removeButton.type = 'button';
        removeButton.className = 'charms__selected-slot-remove';
        removeButton.dataset.charmsRemoveSlot = 'true';
        removeButton.dataset.charmVariantId = variantId;
        removeButton.setAttribute('aria-label', removeLabelText);

        const removeIcon = document.createElement('span');
        removeIcon.className = 'charms__selected-slot-remove-icon';
        removeIcon.setAttribute('aria-hidden', 'true');
        removeIcon.textContent = '×';

        removeButton.append(removeIcon);
        slotContent.append(removeButton);
      }

      const slotMedia = document.createElement('div');
      slotMedia.className = 'charms__selected-slot-media';

      if (image) {
        const slotImage = document.createElement('img');
        slotImage.className = 'charms__selected-slot-image';
        slotImage.src = image;
        slotImage.alt = title;
        slotImage.loading = 'lazy';
        slotMedia.append(slotImage);
      }

      const slotText = document.createElement('span');
      slotText.className = empty
        ? 'charms__selected-slot-text charms__selected-slot-text--empty'
        : 'charms__selected-slot-text';
      slotText.textContent = title;

      slotContent.append(slotMedia, slotText);
      return slotContent;
    };

    const resetSlot = (slot) => {
      slot.classList.remove('charms__selected-slot--filled');
      slot.classList.add('charms__selected-slot--empty');
      delete slot.dataset.charmVariantId;
      slot.replaceChildren(createSlotContent({ empty: true }));
    };

    const fillSlot = (slot, label) => {
      const title = label?.dataset.charmTitle || '';
      const image = label?.dataset.charmImage || '';
      const variantId = label?.querySelector('.charms__checkbox')?.value || '';

      slot.classList.remove('charms__selected-slot--empty');
      slot.classList.add('charms__selected-slot--filled');
      slot.dataset.charmVariantId = variantId;
      slot.replaceChildren(createSlotContent({ title, image, removeLabelText: removeLabel, variantId }));
    };

    const getCardElements = (card) => {
      return {
        checkbox: card.querySelector('.charms__checkbox'),
        quantityInput: card.querySelector('[data-charm-quantity-input]'),
        quantityDisplay: card.querySelector('[data-charm-qty-display]'),
        decreaseButton: card.querySelector('[data-charm-qty-action="decrease"]'),
        increaseButton: card.querySelector('[data-charm-qty-action="increase"]'),
      };
    };

    const getCardQuantity = (card) => {
      const { quantityInput } = getCardElements(card);
      const quantity = parseInt(quantityInput?.value || '0', 10);
      return Number.isFinite(quantity) ? quantity : 0;
    };

    const getCardStockLimit = (card) => {
      const stock = parseInt(card.dataset.charmStock || `${maxAllowed}`, 10);
      return Number.isFinite(stock) && stock > 0 ? stock : maxAllowed;
    };

    const setCardQuantity = (card, nextQuantity) => {
      const { checkbox, quantityInput } = getCardElements(card);
      if (!checkbox || !quantityInput) return;

      const safeQuantity = Math.max(0, nextQuantity);
      quantityInput.value = `${safeQuantity}`;
      quantityInput.disabled = safeQuantity < 1;
      checkbox.checked = safeQuantity > 0;
      card.classList.toggle('segmented__option--selected', safeQuantity > 0);
    };

    const findCardByVariantId = (variantId) => {
      for (const card of cards) {
        const { checkbox } = getCardElements(card);
        if (checkbox?.value === variantId) return card;
      }

      return null;
    };

    const update = () => {
      const selectedUnits = [];

      for (const card of cards) {
        const { checkbox, quantityInput, quantityDisplay } = getCardElements(card);
        if (!checkbox || !quantityInput) continue;

        const quantity = getCardQuantity(card);
        checkbox.checked = quantity > 0;
        quantityInput.disabled = quantity < 1;
        card.classList.toggle('segmented__option--selected', quantity > 0);
        if (quantityDisplay) quantityDisplay.textContent = `${quantity}`;

        for (let index = 0; index < quantity; index += 1) {
          selectedUnits.push(card);
        }
      }

      const count = selectedUnits.length;

      if (selectedCount) selectedCount.textContent = count;
      if (selectedSlots.length > 0) {
        for (const slot of selectedSlots) resetSlot(slot);

        for (const [index, card] of selectedUnits.entries()) {
          const slot = selectedSlots[index];
          if (!slot) break;
          fillSlot(slot, card);
        }
      }

      // Enforce max selection by disabling remaining unchecked boxes,
      // but never override initially disabled (sold-out) state
      for (const cb of checkboxes) {
        const isInitiallyDisabled = initialDisabled.get(cb) === true;
        const label = cb.closest('label.segmented__option');
        const buttonEl = label?.querySelector('.segmented__button');
        const quantity = label ? getCardQuantity(label) : 0;
        const stockLimit = label ? getCardStockLimit(label) : maxAllowed;
        const maxForCard = Math.min(stockLimit, maxAllowed - count + quantity);
        const companionHidden = label?.querySelector('input[type="hidden"][data-charm-companion="with-product"]');
        const refHidden = label?.querySelector('input[type="hidden"][data-charm-companion="ref"]');
        const customizedAtHidden = label?.querySelector('input[type="hidden"][data-charm-companion="customized-at"]');
        const addOnTypeHidden = label?.querySelector('input[type="hidden"][data-charm-companion="add-on-type"]');
        const { decreaseButton, increaseButton } = label ? getCardElements(label) : {};

        // Sync hidden property with checkbox state
        if (companionHidden) companionHidden.disabled = quantity < 1;
        if (refHidden) refHidden.disabled = quantity < 1;
        if (customizedAtHidden) customizedAtHidden.disabled = quantity < 1;
        if (addOnTypeHidden) addOnTypeHidden.disabled = quantity < 1;

        if (quantity < 1) {
          const shouldLock = count >= maxAllowed;
          cb.disabled = isInitiallyDisabled || shouldLock;
          buttonEl?.setAttribute('aria-disabled', isInitiallyDisabled || shouldLock ? 'true' : 'false');
        } else {
          cb.disabled = isInitiallyDisabled;
          buttonEl?.setAttribute('aria-disabled', isInitiallyDisabled ? 'true' : 'false');
        }

        if (decreaseButton) decreaseButton.disabled = isInitiallyDisabled || quantity < 1;
        if (increaseButton) increaseButton.disabled = isInitiallyDisabled || quantity >= maxForCard;
      }

      // Require at least one selection to enable submit (don’t override initial disabled state)
      if (submit) {
        if (count < 1) {
          submit.disabled = true;
        } else if (!initiallyDisabled) {
          submit.disabled = false;
        }
      }
    };

    for (const card of cards) {
      const { checkbox, decreaseButton, increaseButton } = getCardElements(card);
      if (!checkbox) continue;

      card.addEventListener('click', (event) => {
        if (event.target.closest('.charms__quantity-button')) return;
        event.preventDefault();

        if (initialDisabled.get(checkbox) === true) return;
        if (getCardQuantity(card) > 0) return;

        setCardQuantity(card, 1);
        update();
      });

      checkbox.addEventListener('click', (event) => {
        event.preventDefault();
      });

      decreaseButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setCardQuantity(card, getCardQuantity(card) - 1);
        update();
      });

      increaseButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        setCardQuantity(card, getCardQuantity(card) + 1);
        update();
      });
    }

    selectedSlotsContainer?.addEventListener('click', (event) => {
      const removeButton = event.target.closest('[data-charms-remove-slot]');
      if (!removeButton) return;

      event.preventDefault();
      event.stopPropagation();

      const card = findCardByVariantId(removeButton.dataset.charmVariantId || '');
      if (!card) return;

      setCardQuantity(card, getCardQuantity(card) - 1);
      update();
    });

    // Init state
    update();
  }
})();
